<template>
  <div class="duration-wrap">
    <!-- 产品需求临时变更，先不上选学标签相关
    <a-checkbox @change="onChange" :checked="notStudyCtrChecked" v-if="layOutNormal && showNotStudyCtr" :disabled="!editEnable">
      <span class="set-not-study">所有“选学”设为不学</span>
    </a-checkbox>
    -->
    <div class="in-lesson-duration" :class="[!layOutNormal && 'in-lesson-duration-columns']">
      <!-- <span class="total">总时长: {{ duration.total }}</span> -->
      <span v-gdd-hide>
        <span>课前总时长：</span>
        <span>{{ duration.before }}</span>
      </span>
      <span class="course-middle">
        <span>课中总时长：</span>
        <span>{{ duration.middle }}</span>
      </span>
      <span v-gdd-hide>
        <span>课后总时长：</span>
        <span>{{ duration.after }}</span>
      </span>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    checkNotStudy: {
      type: Boolean,
      default: () => false
    },
    showNotStudyCtr: {
      type: Boolean,
      default: false
    },
    editEnable: {
      type: Boolean,
      default: () => false
    },
    layOutNormal: { // 布局标识
      type: Boolean,
      default: true
    },
    duration: {
      type: Object,
      default: () => (
        {
          total: '00:00:00',
          before: '00:00:00',
          middle: '00:00:00',
          after: '00:00:00'
        }
      )
    }
  },
  watch: {
    checkNotStudy(v) {
      this.notStudyCtrChecked = v
    }
  },
  data() {
    return {
      notStudyCtrChecked: false
    }
  },
  methods: {
    onChange(e) {
      this.notStudyCtrChecked = e.target.checked
      this.$emit('setNotStudy', e.target.checked)
    }
  }
}
</script>
<style scoped lang="less">
.duration-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow-x: overlay;
  white-space: nowrap;
  &::-webkit-scrollbar { width: 0 !important }
  .set-not-study {
    font-family: 'Microsoft YaHei UI';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0.04em;
    color: #505873;
  }
  .in-lesson-duration {
    padding: 8px;
    white-space: nowrap;
    transition: all 0.3s ease;
    > span {
      font-size: 12px;
      line-height: 18px;
      color: #505873;
      > span:first-child {
        font-weight: 400;
      }
      > span:last-child {
        font-weight: 700;
      }
    }

    .total {
      display: inline-block;
      width: 175px;
      padding-left: 0;
      border-left: 0;
    }
    .course-middle {
      margin: 0 8px;
    }
  }
  .in-lesson-duration-columns {
    display: flex;
    flex-direction: column;
    padding: 8px 0 12px 8px;
    transition: all 0.3s ease;
    .course-middle {
      margin: 0;
    }
  }
}
</style>